module.exports = __webpack_public_path__ + "img/icon-eye-closed.fcaf1544.svg";